import PicturesWall from './picturesWall';

export default PicturesWall;
